import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

/**
 * Thrown when `git push` failed due to any other reason than failed ACL permission check.
 */
export class GitPushError<TBody extends object = object> extends GitError {
  constructor(message: string, _append: boolean, body?: TBody) {
    super(message);
    this.body = body;
  }
  gitErrorCode = GitErrorStatusCode.GitPush;
  body?: TBody;
}
